import IGBT_IMAGE from '../../images/category/igbt.svg';
import IPM_IMAGE from '../../images/category/ipm.svg';
import JFET_IMAGE from '../../images/category/jfet.svg';
import SMART_SWITCH_IMAGE from '../../images/category/smart_switch.svg';
import MOSFET_IMAGE from '../../images/category/mosfet.svg';
import OP_AMP_IMAGE from '../../images/category/op_amp.svg';
import ANALOG_BJT_IMAGE from '../../images/category/analog_bjt.svg';
import DIGITAL_BJT_IMAGE from '../../images/category/digital_bjt.svg';
import RF_BJT_IMAGE from '../../images/category/rf_bjt.svg';
import GATE_DRIVER_IMAGE from '../../images/category/gate_driver.svg';
import POWER_SUPPLY_IMAGE from '../../images/category/power_supply.svg';
import POWER_DIODE_IMAGE from '../../images/category/power_diode.svg';
import ZENER_DIODE_IMAGE from '../../images/category/zener_diode.svg';
import SMALL_SIGNAL_RF_VER1_IMAGE from '../../images/category/small_signal_rf_ver1.svg';
import COMPARATOR_IMAGE from '../../images/category/comparator.svg';
import AUDIO_AMPLIFIER_IMAGE from '../../images/category/audioamplifier.svg';
import SMART_POWER_STAGE_IMAGE from '../../images/category/smartpowerstage.svg';
import PROTECTED_POWER_SWITCH_IMAGE from '../../images/category/efuse_ecoSwitch.svg';
import CLOCK_GENERATION_IMAGE from '../../images/category/clock_generator.svg';
import POWER_INTEGRATED_MODULE_IMAGE from '../../images/category/pim.svg';
import IMAGE_SENSORS from '../../images/category/image_sensors.svg';
import VOLTAGE_REFERENCE_IMAGE from '../../images/category/Voltage_Reference.svg';
import VOLTAGE_SUPERVISORS_IMAGE from '../../images/category/voltage_supervisors.svg';
import LED_DRIVER_IMAGE from '../../images/category/ledDriver.svg';
import LEVEL_TRASLATORS_IMAGE from '../../images/category/level_translators.svg';
import ESD_PROTECTION_DIODES_IMAGE from '../../images/category/esd_diode.svg';
import { getDomain } from '../../utils/config';

const domain = getDomain();
/*
 * property names must be aligned with property names of categories in CATEGORY_HIERARCHY
 */
export const CATEGORY_FILTERS = {
	technology: {
		POWER_MODULES: 'powerModules',
		TRANSISTORS: 'transistors',
		SESNORS: 'sensors',
		POWER_SUPPLIES_AND_MANAGMENT: 'powerSuppliesAndManagement',
		GATE_DRIVERS: 'gateDrivers',
		DIODES: 'diodes',
		DIGITAL_DEVICES: 'digitalDevices',
		AMPLIFIERS: 'amplifiers',
		LEVEL_TRANSLATORS: 'levelTranslators'
	}
};

/* https://confluence./display/DESIGNTOOL/Taxonomies+plan */
export const CATEGORIES = {
	IGBT: 'igbt',
	IPM: 'ipm',
	JFET: 'jfet',
	SMART_SWITCH: 'smartSwitch',
	MOSFET: 'mosfet',
	OP_AMP: 'opAmp',
	ANALOG_BJT: 'analogBjt',
	DIGITAL_BJT: 'digitalBjt',
	RF_BJT: 'rfBjt',
	POWER_DIODE: 'powerDiode',
	ZENER_DIODE: 'zenerDiode',
	SMALL_SIGNAL_DIODE: 'smallSignalDiode',
	GATE_DRIVER: 'gateDriver',
	POWER_SUPPLY: 'powerSupply',
	COMPARATOR: 'comparator',
	AUDIO_AMPLIFIER: 'audioAmplifier',
	SMART_POWER_STAGE: 'smartPowerStage',
	PROTECTED_POWER_SWITCH: 'protectedPowerSwitch',
	CLOCK_GENERATION: 'clockGeneration',
	POWER_INTEGRATED_MODULE: 'powerIntegratedModule',
	IMAGE_SENSORS: 'imageSensors',
	VOLTAGE_REFERENCE: 'voltageReference',
	VOLTAGE_SUPERVISORS: 'voltageSupervisor',
	LED_DRIVER: 'ledDriver',
	LEVEL_TRANSLATOR: 'levelTranslator',
	ESD_PROTECTION_DIODE: 'esdProtectionDiode'
};

export const CATEGORY_IMAGES = {
	[CATEGORIES.IGBT]: IGBT_IMAGE,
	[CATEGORIES.IPM]: IPM_IMAGE,
	[CATEGORIES.JFET]: JFET_IMAGE,
	[CATEGORIES.SMART_SWITCH]: SMART_SWITCH_IMAGE,
	[CATEGORIES.MOSFET]: MOSFET_IMAGE,
	[CATEGORIES.OP_AMP]: OP_AMP_IMAGE,
	[CATEGORIES.ANALOG_BJT]: ANALOG_BJT_IMAGE,
	[CATEGORIES.DIGITAL_BJT]: DIGITAL_BJT_IMAGE,
	[CATEGORIES.RF_BJT]: RF_BJT_IMAGE,
	[CATEGORIES.ZENER_DIODE]: ZENER_DIODE_IMAGE,
	[CATEGORIES.SMALL_SIGNAL_DIODE]: SMALL_SIGNAL_RF_VER1_IMAGE,
	[CATEGORIES.GATE_DRIVER]: GATE_DRIVER_IMAGE,
	[CATEGORIES.POWER_SUPPLY]: POWER_SUPPLY_IMAGE,
	[CATEGORIES.POWER_DIODE]: POWER_DIODE_IMAGE,
	[CATEGORIES.COMPARATOR]: COMPARATOR_IMAGE,
	[CATEGORIES.AUDIO_AMPLIFIER]: AUDIO_AMPLIFIER_IMAGE,
	[CATEGORIES.SMART_POWER_STAGE]: SMART_POWER_STAGE_IMAGE,
	[CATEGORIES.PROTECTED_POWER_SWITCH]: PROTECTED_POWER_SWITCH_IMAGE,
	[CATEGORIES.CLOCK_GENERATION]: CLOCK_GENERATION_IMAGE,
	[CATEGORIES.IMAGE_SENSORS]: IMAGE_SENSORS,
	[CATEGORIES.POWER_INTEGRATED_MODULE]: POWER_INTEGRATED_MODULE_IMAGE,
	[CATEGORIES.VOLTAGE_REFERENCE]: VOLTAGE_REFERENCE_IMAGE,
	[CATEGORIES.VOLTAGE_SUPERVISORS]: VOLTAGE_SUPERVISORS_IMAGE,
	[CATEGORIES.LED_DRIVER]: LED_DRIVER_IMAGE,
	[CATEGORIES.LEVEL_TRANSLATOR]: LEVEL_TRASLATORS_IMAGE,
	[CATEGORIES.ESD_PROTECTION_DIODE]: ESD_PROTECTION_DIODES_IMAGE
};

export const CATEGORY_HIERARCHY = {
	categories: [
		{
			id: CATEGORIES.MOSFET,
			technology: CATEGORY_FILTERS.technology.TRANSISTORS,
			pathParam: 'mosfet',
			apiParam: 'Mosfets',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: true,
			spiceLiveModelSupported: true,
			elitePairingStudioSupported: true,
			needGatedDriverSupported: 'simple'
		},
		{
			id: CATEGORIES.GATE_DRIVER,
			technology: CATEGORY_FILTERS.technology.GATE_DRIVERS,
			pathParam: 'gate-driver',
			apiParam: 'gateDriver',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			elitePairingStudioSupported: true,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.POWER_SUPPLY,
			technology: CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT,
			pathParam: 'power-supply',
			apiParam: 'powerSupply',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: true,
			chartSupported: false,
			spiceLiveModelSupported: true,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.POWER_DIODE,
			technology: CATEGORY_FILTERS.technology.DIODES,
			pathParam: 'power-diode',
			apiParam: 'powerDiode',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.ANALOG_BJT,
			technology: [CATEGORY_FILTERS.technology.TRANSISTORS, CATEGORY_FILTERS.technology.AMPLIFIERS],
			pathParam: 'analog-bjt',
			apiParam: 'analogBJT',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: true,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.POWER_INTEGRATED_MODULE,
			technology: CATEGORY_FILTERS.technology.POWER_MODULES,
			pathParam: 'pim',
			apiParam: 'pim',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			elitePairingStudioSupported: true,
			needGatedDriverSupported: 'simple'
		},
		{
			id: CATEGORIES.IMAGE_SENSORS,
			technology: CATEGORY_FILTERS.technology.SESNORS,
			pathParam: 'image-sensors',
			apiParam: 'imageSensors',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false
		},
		{
			id: CATEGORIES.IGBT,
			technology: CATEGORY_FILTERS.technology.TRANSISTORS,
			pathParam: 'igbt',
			apiParam: 'Igbt',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: true,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: 'advance'
		},
		{
			id: CATEGORIES.IPM,
			technology: CATEGORY_FILTERS.technology.POWER_MODULES,
			pathParam: 'ipm',
			apiParam: 'Ipm',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: true,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.PROTECTED_POWER_SWITCH,
			technology: [CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT, CATEGORY_FILTERS.technology.TRANSISTORS],
			pathParam: 'protected-power-switch',
			apiParam: 'protectedPowerSwitches',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.OP_AMP,
			technology: CATEGORY_FILTERS.technology.AMPLIFIERS,
			pathParam: 'op-amp',
			apiParam: 'OpAmp',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.SMART_SWITCH,
			technology: [CATEGORY_FILTERS.technology.TRANSISTORS, CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT],
			pathParam: 'smart-switch',
			apiParam: 'ProtMosfet',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.SMALL_SIGNAL_DIODE,
			technology: CATEGORY_FILTERS.technology.DIODES,
			pathParam: 'small-signal-rf-diode',
			apiParam: 'smallSignalAndRFDiode',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.SMART_POWER_STAGE,
			technology: CATEGORY_FILTERS.technology.POWER_MODULES,
			pathParam: 'smart-power-stage',
			apiParam: 'smartPowerStage',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.JFET,
			technology: CATEGORY_FILTERS.technology.TRANSISTORS,
			pathParam: 'jfet',
			apiParam: 'JFet',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.VOLTAGE_REFERENCE,
			technology: CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT,
			pathParam: 'voltage-references',
			apiParam: 'voltageReferences',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.COMPARATOR,
			technology: CATEGORY_FILTERS.technology.DIGITAL_DEVICES,
			pathParam: 'comparator',
			apiParam: 'comparators',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.ZENER_DIODE,
			technology: CATEGORY_FILTERS.technology.DIODES,
			pathParam: 'zener-diode',
			apiParam: 'zenerDiode',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.DIGITAL_BJT,
			technology: [CATEGORY_FILTERS.technology.TRANSISTORS, CATEGORY_FILTERS.technology.DIGITAL_DEVICES],
			pathParam: 'digital-bjt',
			apiParam: 'digitalBJT',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.RF_BJT,
			technology: [CATEGORY_FILTERS.technology.TRANSISTORS, CATEGORY_FILTERS.technology.AMPLIFIERS],
			pathParam: 'rf-bjt',
			apiParam: 'rfBJT',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.CLOCK_GENERATION,
			technology: CATEGORY_FILTERS.technology.DIGITAL_DEVICES,
			pathParam: 'clock-generation',
			apiParam: 'clockGeneration',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.AUDIO_AMPLIFIER,
			technology: CATEGORY_FILTERS.technology.AMPLIFIERS,
			pathParam: '',
			apiParam: '',
			redirectParam: `https://www.${domain}/products/signal-conditioning-control/amplifiers-comparators/audio-power-amplifiers#products`,
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.LEVEL_TRANSLATOR,
			technology: CATEGORY_FILTERS.technology.DIGITAL_DEVICES,
			pathParam: 'level-translators',
			apiParam: 'levelTranslators',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: true,
			spiceLiveModelSupported: false
		},
		{
			id: CATEGORIES.ESD_PROTECTION_DIODE,
			technology: CATEGORY_FILTERS.technology.DIODES,
			pathParam: 'esd-protection-diode',
			apiParam: 'esdProtectionDiode',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.LED_DRIVER,
			technology: CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT,
			pathParam: 'led-drivers',
			apiParam: 'ledDrivers',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: true,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false,
			needGatedDriverSupported: false
		},
		{
			id: CATEGORIES.VOLTAGE_SUPERVISORS,
			technology: CATEGORY_FILTERS.technology.POWER_SUPPLIES_AND_MANAGMENT,
			pathParam: '',
			apiParam: '',
			redirectParam: '',
			filterParams: '',
			categories: [],
			released: false,
			wdSupported: false,
			chartSupported: false,
			spiceLiveModelSupported: false
		}
		/* {
            id: CATEGORIES.testCatL1,
            pathParam: 'testCatL1',
            apiParam: 'testCatL1',
            filterParams: '',
            categories: [
                {
                    id: CATEGORIES.testCatL1_testCatL2,
                    pathParam: 'testCatL2',
                    apiParam: 'testCatL2',
                    filterParams: '',
                    categories: [
                        {
                            id: CATEGORIES.testCatL1_testCatL2_testCatL3_1,
                            pathParam: 'testCatL3-1',
                            apiParam: 'testCatL3-1',
                            filterParams: '',
                        },
                        {
                            id: CATEGORIES.testCatL1_testCatL2_testCatL3_2,
                            pathParam: null,
                            apiParam: null,
                            filterParams:
                                'testParam1>=1&testParam1<10&testParam2=testValue',
                        },
                    ],
                },
            ],
        },*/
	]
};

export default CATEGORY_HIERARCHY;
